import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NavController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';
import { AnalyticsServicesNameEnum } from 'src/app/core/services/analytics/enums/analytics-services-name.enum';
import { FlexJobsService } from 'src/app/pages/flex/services/flex-jobs.service';
import { EventTrackingEnum } from 'src/app/shared/enums/event-tracking.enum';
import { Bid } from 'src/app/shared/models/gql/bid.model';
import { JobDetail } from 'src/app/shared/models/gql/job-detail.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { JobsService } from 'src/app/shared/services/jobs.service';
import { PlatformBackButtonService } from 'src/app/shared/services/platform-back-button.service';

@Component({
  selector: 'app-consumer-open-job',
  templateUrl: './consumer.page.html',
  styleUrls: ['./consumer.page.scss'],
})
export class ConsumerOpenJobPage implements OnInit {
  public job: JobDetail;

  jobId: number;

  // bids for last minute job
  bids: Bid[] = [];

  // Jobs bids broadcaster subscription
  jobsBidsSubsription: Subscription;

  // url to navigate to forcefully
  forcedUrl = '/tabs/jobs';

  // the source of redirection to this page
  source: string;

  constructor(
    public navCtrl: NavController,
    public flexJobsService: FlexJobsService,
    public auth: AuthService,
    private route: ActivatedRoute,
    public jobsService: JobsService,
    private platformBackButtonService: PlatformBackButtonService,
    private analyticsService: AnalyticsService,
  ) {}

  ngOnInit() {
    const { paramMap, queryParamMap } = this.route.snapshot;
    this.jobId = Number(paramMap.get('id'));
    this.source = queryParamMap.get('source');
  }

  async ionViewDidEnter() {
    // subscribe to the platform back button which forced the default back navigation
    this.platformBackButtonService.addForcedRedirection(this.forcedUrl);
    // get job details
    this.getJobDetails().then(() => {
      this.analyticsService.track(
        EventTrackingEnum.JOB_VIEWED,
        { job_id: this.job?.id?.toString() },
        AnalyticsServicesNameEnum.SEGMENT_SERVICE,
      );
    });

    await this.flexJobsService.subscribeToJobBidsChannel(this.jobId);
    this.getJobBids();
  }

  ionViewDidLeave() {
    this.flexJobsService.unsubscribeFromChannel();
    // unsubscribe to the platform back button
    this.platformBackButtonService.removeForcedRedirection();
  }

  /**
   * Get job details.
   *
   */
  async getJobDetails() {
    try {
      this.job = await this.jobsService.getPostedJobDetailsById(this.jobId);
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Get jobs bids and when it change get latest
   */
  getJobBids() {
    this.jobsBidsSubsription = this.flexJobsService.jobBidsBroadcaster().subscribe((res) => {
      this.bids = res.map((bid) => ({
        user: {
          id: bid?.user_id,
          avatar: {
            small: bid?.avatar,
          },
          truncatedName: bid?.name,
          profile: {
            combinedFeedback: bid?.combined_feedback,
          },
        },
        distance: bid?.distance,
        amount: bid?.amount,
        comment: bid?.comment,
        postedJob: {
          id: bid?.posted_job_id,
        },
      }));
    });
  }
}
